var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{class:_vm.$i18n.locale},[(!_vm.ClosePreloader)?_c('app-preloader'):_c('div',[_c('navbar'),_c('v-main',{staticClass:"pt-0 main-section",attrs:{"transition":"none"}},[_c('vue-progress-bar'),_c('router-view')],1),(_vm.$route.name !== 'Chat')?_c('foote'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }